import { fk, attr } from 'redux-orm'
import Base from './Base'

class Invoice extends Base {
  static get fields() {
    return {
      id: attr(),
      createdAt: attr(),
      paid: attr(),
      identification: attr(),
      proposed: attr(),
      formattedIdentification: attr(),
      invoiceDate: attr(),
      sendInvoiceWarning: attr(),
      payedAt: attr(),
      concept: attr(),
      dossierId :fk({to: 'dossier', as: 'dossier', relatedName: 'invoices'}),
      responsibleId :fk({to: 'employment', as: 'responsible', relatedName: 'invoices'}),
      receiverId :attr(),
      receiverType :attr(),
      senderConfigId: attr(),
      creditNoteReferenceInvoiceId: attr(),
      creditNoteReason: attr(),
      anonymized: attr(),
    }
  }
}

Invoice.modelName = 'invoice'

export default Invoice;
